import * as React from "react"

import { Grid, Spacer } from "@molnx-sites/common/components"

import { Page, PageHeader, PageSection, DocBox, SEO } from "src/components"

export default function IndexPage() {
    return (
        <Page>
            <SEO title="Home"/>
            <PageHeader header="Documentation"/>

            <PageSection>
                <h1>Services</h1>
                <Spacer height="medium"/>
                <DocBoxGrid>
                    {DispatchBox}
                </DocBoxGrid>
            </PageSection>

            <PageSection>
                <h1>Core Platform</h1>
                <Spacer height="medium"/>
                <DocBoxGrid>
                    {IAMBox}
                    {BillingBox}
                </DocBoxGrid>
            </PageSection>

            <PageSection>
                <p>
                    If you have any questions that you're unable to find the answer for, please don't hesitate to
                    contact <a href="https://molnx.com/support">support</a>.
                </p>
            </PageSection>
        </Page>
    )
}

function DocBoxGrid(props: { children: any }) {
    return (
        <Grid
            templateColumns="repeat(auto-fit, minmax(auto, 400px))"
            templateRows="auto"
            columnGap={40}
            rowGap={40}
        >
            {props.children}
        </Grid>
    )
}

const IAMBox =
    <DocBox
        title="Identity & Access Management (IAM)"
        indexPath="/iam"
        description="Manage your organization members and applications"
        links={[{
            to: "/iam",
            children: "Index"
        }, {
            to: "/iam/configuration",
            children: "Configuration"
        }, {
            to: "/iam/reference",
            children: "Reference"
        }, {
            to: "/iam/faq",
            children: "FAQ"
        }]}
    />

const BillingBox =
    <DocBox
        title="Billing"
        indexPath="/billing"
        description="Manage your billing information"
        links={[{
            to: "/billing",
            children: "Index"
        }, {
            to: "/billing/faq",
            children: "FAQ"
        }]}
    />

const DispatchBox =
    <DocBox
        title="Dispatch"
        indexPath="/dispatch"
        description="Easy application message scheduling"
        links={[{
            to: "/dispatch",
            children: "Index"
        }, {
            to: "/dispatch/configuration",
            children: "Configuration"
        }, {
            to: "/dispatch/reference",
            children: "Reference"
        }, {
            to: "/dispatch/faq",
            children: "FAQ"
        }]}
    />